import React from "react";
import BlogEight from "../component/BlogEight";

function BlogEightContainer() {
  return <BlogEight />;
}
export default BlogEightContainer;
